<template>
  <div class="course-section">
    <!-- Header -->
    <div class="section-header">
      <div class="section-title">
        <span class="title-bar"></span>
        <span class="title-text">精品课程</span>
      </div>
    </div>

    <!-- 专业 Tab -->
    <div class="major-tabs">
      <span
        v-for="tab in majorTabs"
        :key="tab.value"
        :class="['major-tab', { active: activeTab === tab.value }]"
        @click="activeTab = tab.value"
      >{{ tab.label }}</span>
    </div>

    <!-- 课程类型筛选 -->
    <div class="sub-filters">
      <span class="filter-label">课程类型：</span>
      <span
        v-for="tt in courseTypes"
        :key="tt.value"
        :class="['sub-tag', { active: activeType === tt.value }]"
        @click="activeType = tt.value"
      >{{ tt.label }}</span>
    </div>

    <!-- Course Grid -->
    <div class="course-grid-wrap">
      <div class="course-grid" v-if="filteredCourses.length > 0">
        <div
          class="course-card"
          @click="goDetail(item)"
          v-for="item in filteredCourses"
          :key="item.id"
        >
          <div class="card-header">
            <!-- 专业背景SVG - 底层装饰 -->
            <div class="card-bg-icon">
              <svg viewBox="0 0 80 80" fill="none" stroke="rgba(255,255,255,0.2)" stroke-width="1.5">
                <template v-if="isCat(item, '建筑')">
                  <rect x="12" y="28" width="20" height="44" rx="2" fill="rgba(255,255,255,0.04)" />
                  <rect x="40" y="16" width="20" height="56" rx="2" fill="rgba(255,255,255,0.05)" />
                  <rect x="26" y="38" width="16" height="34" rx="2" fill="rgba(255,255,255,0.04)" />
                  <line x1="16" y1="28" x2="12" y2="18" /><line x1="28" y1="28" x2="32" y2="18" />
                  <line x1="44" y1="16" x2="40" y2="6" /><line x1="56" y1="16" x2="60" y2="6" />
                </template>
                <template v-else-if="isCat(item, '市政')">
                  <path d="M4,54 C4,54 14,20 40,20 C66,20 76,54 76,54" fill="rgba(255,255,255,0.04)" />
                  <line x1="10" y1="54" x2="70" y2="54" />
                  <rect x="8" y="54" width="6" height="10" rx="1" fill="rgba(255,255,255,0.05)" />
                  <rect x="66" y="54" width="6" height="10" rx="1" fill="rgba(255,255,255,0.05)" />
                </template>
                <template v-else-if="isCat(item, '机电')">
                  <circle cx="40" cy="40" r="18" fill="rgba(255,255,255,0.04)" />
                  <circle cx="40" cy="40" r="6" fill="rgba(255,255,255,0.05)" />
                  <rect x="38" y="4" width="4" height="14" rx="2" />
                  <rect x="38" y="62" width="4" height="14" rx="2" />
                  <rect x="4" y="38" width="14" height="4" rx="2" />
                  <rect x="62" y="38" width="14" height="4" rx="2" />
                </template>
                <template v-else-if="isCat(item, '公路')">
                  <path d="M2,34 C10,22 20,42 40,34 C60,26 70,42 78,34" />
                  <path d="M2,46 C10,34 20,54 40,46 C60,38 70,54 78,46" fill="rgba(255,255,255,0.04)" />
                  <line x1="10" y1="34" x2="10" y2="46" /><line x1="70" y1="34" x2="70" y2="46" />
                </template>
                <template v-else-if="isCat(item, '水利')">
                  <path d="M4,30 L18,16 L62,16 L76,30" fill="rgba(255,255,255,0.04)" />
                  <rect x="18" y="30" width="44" height="8" rx="2" fill="rgba(255,255,255,0.05)" />
                  <rect x="12" y="54" width="14" height="22" rx="2" fill="rgba(255,255,255,0.04)" />
                  <rect x="54" y="54" width="14" height="22" rx="2" fill="rgba(255,255,255,0.04)" />
                </template>
                <template v-else>
                  <rect x="8" y="10" width="64" height="52" rx="3" fill="rgba(255,255,255,0.04)" />
                  <polygon points="40,4 20,16 40,24 60,16" fill="rgba(255,255,255,0.05)" />
                  <line x1="40" y1="24" x2="40" y2="62" />
                  <line x1="22" y1="62" x2="58" y2="62" />
                </template>
              </svg>
            </div>
            <span :class="['card-badge', item.isRequired === 1 ? 'required' : 'elective']">
              {{ item.isRequired === 1 ? '必修' : '选修' }}
            </span>
            <div class="card-name">{{ getDisplayName(item) }}</div>
          </div>
        </div>
      </div>
      <div class="course-empty" v-else>
        <p>暂无课程</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "index",
  props: {
    categories: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      activeTab: "",
      activeType: "全部",
      courseTypes: [
        { label: "全部", value: "全部" },
        { label: "必修课", value: "必修课" },
        { label: "选修课", value: "选修课" },
      ],
    };
  },
  computed: {
    majorTabs() {
      const tabs = [];
      this.categories.forEach((cat) => {
        if (cat.cateName) {
          tabs.push({ label: cat.cateName, value: cat.cateName });
        }
      });
      // 建筑放在第一个
      tabs.sort((a, b) => {
        if (a.label.indexOf("建筑") !== -1) return -1;
        if (b.label.indexOf("建筑") !== -1) return 1;
        return 0;
      });
      return tabs;
    },
    allCourses() {
      const cat = this.categories.find((c) => c.cateName === this.activeTab);
      return cat ? (cat.courseList || []) : [];
    },
    filteredCourses() {
      let list = this.allCourses;
      if (this.activeType !== "全部") {
        list = list.filter((item) => {
          if (this.activeType === "必修课") return item.isRequired === 1;
          if (this.activeType === "选修课") return item.isRequired !== 1;
          return true;
        });
      }
      return list;
    },
  },
  watch: {
    majorTabs: {
      immediate: true,
      handler(tabs) {
        if (tabs.length > 0 && !this.activeTab) {
          this.activeTab = tabs[0].value;
        }
      },
    },
  },
  methods: {
    isCat(item, keyword) {
      return (item.cateName || "").indexOf(keyword) !== -1;
    },
    getDisplayName(item) {
      const name = item.cateName || item.storeName || "";
      const idx = name.indexOf("-");
      return idx !== -1 ? name.slice(idx + 1) : name;
    },
    goDetail(item) {
      let routeData = this.$router.resolve({ name: "detail", query: { coursesId: item.id } });
      window.open(routeData.href, "_blank");
    },
    goAllSubject() {
      let routeData = this.$router.resolve({ name: "allSubject" });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style scoped lang="scss">
.course-section {
  padding: 24px;
  background: #fff;
  border-radius: 0;
  border: 1px solid #eef0f4;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0;

  .section-title {
    display: flex;
    align-items: center;

    .title-bar {
      width: 4px;
      height: 20px;
      background: #64b5f6;
      border-radius: 2px;
      margin-right: 10px;
    }

    .title-text {
      font-size: 20px;
      font-weight: 700;
      color: #222;
    }
  }

  .section-more {
    font-size: 13px;
    color: #999;
    cursor: pointer;

    &:hover {
      color: #64b5f6;
    }
  }
}

// 专业 Tab
.major-tabs {
  display: flex;
  gap: 0;
  margin: 20px 0 6px;
  border-bottom: 2px solid #e8eaed;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;

  .major-tab {
    padding: 10px 20px;
    font-size: 14px;
    color: #666;
    cursor: pointer;
    position: relative;
    white-space: nowrap;
    transition: color 0.2s;

    &:hover {
      color: #64b5f6;
    }

    &.active {
      color: #64b5f6;
      font-weight: 600;

      &::after {
        content: "";
        position: absolute;
        bottom: -2px;
        left: 0;
        width: 100%;
        height: 2px;
        background: #64b5f6;
      }
    }
  }
}

// 次级筛选
.sub-filters {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 0 16px;
  flex-wrap: wrap;
  overflow-x: auto;

  .filter-label {
    font-size: 13px;
    color: #888;
  }

  .sub-tag {
    padding: 4px 14px;
    font-size: 12px;
    color: #666;
    background: #f5f7fa;
    border-radius: 3px;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      color: #64b5f6;
      background: #e8f0fb;
    }

    &.active {
      color: #fff;
      background: #64b5f6;
    }
  }

  .sep {
    width: 1px;
    height: 16px;
    background: #ddd;
    margin: 0 8px;
  }
}

// Course Grid
.course-grid-wrap {
  min-height: 160px;
}

.course-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 16px;
}

.course-card {
  background: #fff;
  border: 1px solid #eef0f4;
  border-radius: 0;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    box-shadow: 0 8px 24px rgba(66, 165, 245, 0.12);
    transform: translateY(-4px);
    border-color: #64b5f6;
  }

  .card-header {
    height: 130px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;
    background: linear-gradient(160deg, #1565C0 0%, #1976D2 40%, #42A5F5 70%, #64B5F6 100%);

    .card-bg-icon {
      position: absolute;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0.3;
      svg { width: 80px; height: 80px; }
    }

    .card-badge {
      position: absolute;
      top: 10px;
      left: 10px;
      padding: 2px 10px;
      font-size: 11px;
      color: #fff;
      border-radius: 3px;
      letter-spacing: 1px;
      z-index: 2;

      &.required {
        background: #67C23A;
      }

      &.elective {
        background: #E6A23C;
      }
    }

    .card-name {
      font-size: 16px;
      font-weight: 600;
      color: #fff;
      text-align: center;
      line-height: 1.5;
      padding: 0 12px;
      position: relative;
      z-index: 2;
      word-break: break-all;
    }
  }
}

.course-empty {
  padding: 60px 0;
  text-align: center;
  color: #bbb;
  font-size: 14px;
}

@media (max-width: 768px) {
  .course-grid {
    gap: 12px;
  }

  .course-card .card-header {
    height: 110px;

    .card-name {
      font-size: 13px;
      -webkit-line-clamp: 2;
    }
  }

  .major-tabs {
    overflow-x: auto;
  }

  .major-tab {
    padding: 8px 16px;
    font-size: 13px;
    flex-shrink: 0;
  }
}
</style>
